import '../../assets/css/wallet.css';

import { Component } from 'react';
import DataTable  from 'react-data-table-component';

import {formatNumber, navigateTo, showNotification} from "../../lib/helper";
import {connect} from "react-redux";
import {fetchingUser, fetchingUserSuccess} from "../../redux/actions";
import {withRouter} from "react-router-dom";
import api from "../../lib/api";
import DateRangePicker from "../../lib/custom/DateRangePicker";
import moment from "moment";

class Wallet extends Component {
	constructor(props) {
		super(props);
		this.state = {
			withdrawal_amount: 0,
			withdrawal_bank_name: '',
			withdrawal_bank_number: '',
			withdrawal_bank_account: '',
			is_show_withdrawal_box: false,
			page: 1,
			per_page: 10,
			data: [],
			total: 0,

			sort_selector: 'created_at',
			sort_direction: 'desc',
			filter_from: moment().subtract(1,'months'),
			filter_to: moment(),

			otp: ''
		};
		this.columns = [
			{
				name: 'Mã giao dịch',
				selector: 'code',
				sortable: false,
			},
			{
				name: 'Thời gian bắt đầu',
				selector: 'created_at',
				sortable: true,
			},
			{
				name: 'Loại tài khoản',
				selector: 'point_type_label',
				data: 'point_type',
				sortable: true,
				format: (row) => (<span className={'point_type '+row.point_type}>{row.point_type_label}</span>)
			},
			{
				name: 'Loại giao dịch',
				selector: 'transaction_type_label',
				data: 'transaction_type',
				sortable: true,
				format: (row, index) => (<span className={'transaction_type '+row.transaction_type}>{row.transaction_type_label}</span>),
				allowOverflow: true
			},
			{
				name: 'Người gửi/nhận',
				selector: 'transaction_type_label',
				data: 'transaction_type',
				sortable: true,
				format: (row, index) => (<span>{row.transfer_relation ? row.transfer_relation.display_name : ''}</span>),
				allowOverflow: true
			},
			{
				name: 'Trạng thái',
				selector: 'transaction_status_label',
				data: 'transaction_status',
				sortable: true,
				format: (row, index) => (<span className={'transaction_status '+row.transaction_status}>{row.transaction_status_label}</span>),
				allowOverflow: true
			},
			{
				name: 'Giá trị ($)',
				selector: 'value',
				sortable: true,
				right: true,
				format: (row, index) => (<span style={{ color: row.value < 0 ? 'red' : 'green' }}>{row.value > 0 ? '+' : ''}{formatNumber(row.value)}</span>),
			},
		];
	}

	onChangeInput = (type) => (e) => {
		let value = e.target.value;
		if(type === 'withdrawal_amount'){
			value = parseFloat(value.toString().replace(/,/g,''));
		}
		this.setState({[type]: value});
	}

	onKeyPress = (e) => {
		if (e.code === 'Enter') {
			this.onRequestWithdrawal();
		}
	}

	onSendOTP = () => {
		api.postSendOTP()
			.then(({ message, success, data }) => {
				message && showNotification({ message, type: success ? 'success' : 'danger' });
			});
	}

	onFocusout = () => {
		let { minimum_withdrawal } = this.props.appReducer;
		let {withdrawal_amount} = this.state;
		if(withdrawal_amount < minimum_withdrawal){
			withdrawal_amount = minimum_withdrawal;
		}
		this.setState({ withdrawal_amount });
	}

	onRequestWithdrawal = () => {
		let {
			withdrawal_amount,
			withdrawal_bank_name,
			withdrawal_bank_number,
			withdrawal_bank_account,
			otp
		} = this.state;

		let { minimum_withdrawal } = this.props.appReducer;
		withdrawal_amount = withdrawal_amount !== 0 ? withdrawal_amount : minimum_withdrawal;

		let isDisableButton = !withdrawal_amount || withdrawal_amount.length === 0
			|| !withdrawal_bank_name || withdrawal_bank_name.length === 0
			|| !withdrawal_bank_number || withdrawal_bank_number.length === 0
			|| !withdrawal_bank_account || withdrawal_bank_account.length === 0;
		if (isDisableButton) {
			return false;
		}

		let { real_balance} = this.props.memberReducer || {};
		if(withdrawal_amount > real_balance){
			return showNotification({ message: 'Số tiền cần rút lớn hơn số tiền trong ví', type: 'danger' });
		}

		api.postWithdrawal({ withdrawal_amount, withdrawal_bank_name, withdrawal_bank_number, withdrawal_bank_account, otp })
			.then(({ data, message, success }) => {
				showNotification({ message, type: success ? 'success' : 'danger' });
				if(success){
					this.props.fetchingUser();
					this.onClickWithdrawal();
					this.loadTransaction();
				}
			});
	}

	componentDidMount() {
		if (!this.props.memberReducer?.login_token) {
			return this.props.history.push('/login');
		}
		this.loadTransaction();
	}

	onResetDemoBalance = () => {
		api.resetDemoBalance().then(({data, success, message}) => {
			if (success) {
				this.props.fetchingUserSuccess(data);
				this.loadTransaction();
			}
			showNotification({message, type: success ? 'success' : 'danger'});
		});
	}

	onClickWithdrawal = () => {
		if(!this.props.memberReducer.tl_id){
			return showNotification({message: 'Vui lòng bật xác thực telegram trong Hồ sơ để thực hiện thao tác này!', type: 'danger'});
		}
		this.setState({is_show_withdrawal_box: !this.state.is_show_withdrawal_box})
	}

	onClickTransfer = () => {
		navigateTo('transfer').bind(this)();
	}

	loadTransaction = () => {
		let { page, per_page, sort_selector, sort_direction, filter_from, filter_to } = this.state;
		api.getTransaction({ limit: per_page, page, sort_selector, sort_direction,
			filter_from: filter_from.format('YYYY-MM-DD'),
			filter_to: filter_to.format('YYYY-MM-DD')
		}).then(({ data, success }) => {
				if(success){
					this.setState({ data: data.data, total: data.total });
				}
			})
	}

	handlePageChange = (page) => {
		this.setState({ page }, this.loadTransaction)
	}

	handlePerRowsChange = (per_page) => {
		this.setState({ per_page }, this.loadTransaction)
	}

	onSort = (column, sortDirection) => {
		this.setState({ sort_selector: column.data || column.selector, sort_direction: sortDirection }, this.loadTransaction)
	}

	handleChangeDateRange = (start, end) => {
		this.setState({ filter_from: start, filter_to: end }, this.loadTransaction)
	}

	render() {
		let {demo_balance, real_balance, tl_id} = this.props.memberReducer || {};
		let {
			withdrawal_amount,
			withdrawal_bank_name,
			withdrawal_bank_number,
			withdrawal_bank_account,
			is_show_withdrawal_box,
			data, total,
			filter_from,
			filter_to,
			otp
		} = this.state;
		let { minimum_withdrawal, withdrawal_cost, vnd_per_usd, asset_logo } = this.props.appReducer;
		withdrawal_amount = withdrawal_amount !== 0 ? withdrawal_amount : minimum_withdrawal;
		let isDisableButton = !withdrawal_amount
			|| !withdrawal_bank_name || withdrawal_bank_name.length === 0
			|| !withdrawal_bank_number || withdrawal_bank_number.length === 0
			|| !withdrawal_bank_account || withdrawal_bank_account.length === 0;

		let amount_receive = real_balance - withdrawal_amount - withdrawal_cost; amount_receive = amount_receive > 0 ? amount_receive : 0;
		return (
			<div data-v-b0e45e8c="" id="mainContent">
				<div data-v-b0e45e8c="" className="boxContent">
					<div data-v-efb97944="" data-v-b0e45e8c="" id="binaryPage" sticky-container="">
						<section data-v-7cedfc60="" data-v-efb97944="" className="contentBox mt-4">
							<div data-v-7cedfc60="" className="container">
								<div data-v-7cedfc60="" className="row">
									<div data-v-7cedfc60="" className="col-sm-12 col-md-6" style={{ marginBottom: '20px' }}>
										<div data-v-7cedfc60="" className="background backgroundImg backgroundLive">
											<div data-v-7cedfc60=""
												 className="content d-flex flex-column justify-content-center align-items-center">
												<span data-v-7cedfc60="" className="font-18 color-gray mb-sm-3">Tài khoản Thực</span>
												<span data-v-7cedfc60="" className="price d-flex align-items-center mb-sm-3">
													<span data-v-7cedfc60="" className="font-34">{formatNumber(real_balance)}</span>
												</span>
												<div data-v-7cedfc60="" className="row">
													<div data-v-9792f17c="" className="col-md-6 col-xs-12">
														<button data-v-7cedfc60="" type="button" onClick={this.onClickWithdrawal} className="btn button wbtn btn-large btn-radius w-100">
															<span data-v-7cedfc60="" className="iconSubmit iconSubmitLive"/>
															<span data-v-7cedfc60="">Rút Tiền</span>
														</button>
													</div>
													<div data-v-9792f17c="" className="col-md-6 col-xs-12">
														<button data-v-7cedfc60="" type="button" onClick={this.onClickTransfer} className="btn button wbtn btn-large btn-transfer btn-radius w-100">
															<i className='fas fa-exchange-alt' />
															<span data-v-7cedfc60="">Chuyển Tiền</span>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div data-v-7cedfc60="" className="col-sm-12 col-md-6">
										<div data-v-7cedfc60="" className="background backgroundImg backgroundDemo">
											<div data-v-7cedfc60=""
												 className="content d-flex flex-column justify-content-center align-items-center">
												<span data-v-7cedfc60="" className="font-18 color-gray mb-sm-3">Tài khoản Demo</span>
												<span data-v-7cedfc60=""
													  className="price d-flex align-items-center mb-sm-3"><span
													data-v-7cedfc60=""
													className="font-34">{formatNumber(demo_balance)}</span></span>
												<button data-v-7cedfc60=""
														onClick={this.onResetDemoBalance}
														type="button"
														className="btn button wbtn btn-large btn-radius w-75">
													<span data-v-7cedfc60="" className="iconSubmit iconSubmitDemo"/>
													<span data-v-7cedfc60="">Nạp lại</span>
												</button>
											</div>
										</div>
									</div>
								</div>
								<div data-v-7cedfc60="" style={{display: 'none'}}>
									<div data-v-7cedfc60="" className="swiper-container">
										<div data-v-7cedfc60="" className="swiper-wrapper">
											<div data-v-7cedfc60="" className="swiper-slide">
												<div data-v-7cedfc60=""
													 className="background backgroundImg backgroundLive">
													<div data-v-7cedfc60=""
														 className="content d-flex flex-column justify-content-center align-items-center">
														<span data-v-7cedfc60=""
															  className="font-14 color-gray mb-3 font-weight-normal">Tài khoản Thực</span>
														<span data-v-7cedfc60=""
															  className="price d-flex align-items-center mb-3"><span
															data-v-7cedfc60=""
															className="font-30">{formatNumber(real_balance)}</span></span>
														<button data-v-7cedfc60="" type="button"
																onClick={this.onClickWithdrawal}
																className="btn button wbtn btn-medium btn-radius w-75">
															<span data-v-7cedfc60=""
																  className="iconSubmit iconSubmitLive"/>
															<span data-v-7cedfc60="" className="font-14">Rút Tiền</span>
														</button>
													</div>
												</div>
											</div>
											<div data-v-7cedfc60="" className="swiper-slide">
												<div data-v-7cedfc60=""
													 className="background backgroundImg backgroundDemo">
													<div data-v-7cedfc60=""
														 className="content d-flex flex-column justify-content-center align-items-center">
														<span data-v-7cedfc60=""
															  className="font-14 color-gray mb-3 font-weight-normal">Tài khoản Demo</span>
														<span data-v-7cedfc60=""
															  className="font-30 price d-flex align-items-center mb-3"><span
															data-v-7cedfc60=""
															className="font-30">{formatNumber(demo_balance)}</span></span>
														<button data-v-7cedfc60="" type="button"
																onClick={this.onResetDemoBalance}
																className="btn button wbtn btn-medium btn-radius w-75">
															<span data-v-7cedfc60=""
																  className="iconSubmit iconSubmitDemo"/>
															<span data-v-7cedfc60="" className="font-14">Nạp lại</span>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div data-v-c04d7b2a="" data-v-7cedfc60="">
								<div data-v-c04d7b2a="" tabIndex="-1" role="dialog" aria-hidden="true"
									 className="modal fade modal-info modalTransfer">
									<div data-v-c04d7b2a="" className="modal-dialog">
										<div data-v-c04d7b2a="" className="modal-content-info h-100">
											<button data-v-c04d7b2a="" type="button" aria-label="Close"
													className="close">
												<svg data-v-c04d7b2a="" xmlns="http://www.w3.org/2000/svg"
													 viewBox="0 0 32 32">
													<g data-v-c04d7b2a="" strokeLinecap="square"
													   strokeLinejoin="miter" strokeWidth="2" fill="currentColor"
													   stroke="currentColor" className="nc-icon-wrapper">
														<g data-v-c04d7b2a="" className="nc-interact_menu-close-2-o-32">
															<path data-v-c04d7b2a="" fill="currentColor"
																  stroke="currentColor" strokeMiterlimit="10"
																  d="M2 6h28"
																  transform="translate(0 10.00) rotate(45.00 16 6)"/>
															<path data-v-c04d7b2a="" data-color="color-2"
																  fill="currentColor" strokeMiterlimit="10"
																  d="M2 16h28" opacity="0"/>
															<path data-v-c04d7b2a="" fill="currentColor"
																  stroke="currentColor" strokeMiterlimit="10"
																  d="M2 26h28"
																  transform="translate(0 -10) rotate(-45 16 26)"/>
														</g>
													</g>
												</svg>
											</button>
											<div data-v-c04d7b2a="" className="modal-body-popup text-center">
												<div data-v-c04d7b2a="" className="header d-flex">
													<div data-v-c04d7b2a=""
														 className="leftHeader d-flex flex-column align-items-center">
														<span data-v-c04d7b2a="" className="font-14 mb-2"><span
															data-v-c04d7b2a=""
															className="color-blue text-uppercase">Win</span> <span
															data-v-c04d7b2a="">Wallet</span></span> <span
														data-v-c04d7b2a="" className="font-26 font-weight-700">0</span>
													</div>
													<div data-v-c04d7b2a=""
														 className="rightHeader d-flex flex-column align-items-center">
														<span data-v-c04d7b2a=""
															  className="font-14 mb-2">Tài khoản Thực</span> <span
														data-v-c04d7b2a="" className="font-26 font-weight-700">0</span>
													</div>
													<div data-v-c04d7b2a="" href="#" className="changeAmount pointer">
														<svg data-v-c04d7b2a="" xmlns="http://www.w3.org/2000/svg"
															 width="30" height="30" viewBox="0 0 30 30"
															 className="iconTransfer">
															<g data-v-c04d7b2a="" id="Group_10897"
															   data-name="Group 10897"
															   transform="translate(-559.431 -202.553)">
																<g data-v-c04d7b2a="" id="Group_4613"
																   data-name="Group 4613"
																   transform="translate(559.431 202.553)">
																	<g data-v-c04d7b2a="" id="Rectangle_2919"
																	   data-name="Rectangle 2919"
																	   transform="translate(0)" fill="#e9f0fa"
																	   stroke="#e5e5e5" strokeWidth="1">
																		<rect data-v-c04d7b2a="" width="30" height="30"
																			  rx="15" stroke="none"/>
																		<rect data-v-c04d7b2a="" x="0.5" y="0.5"
																			  width="29" height="29" rx="14.5"
																			  fill="none"/>
																	</g>
																</g>
																<g data-v-c04d7b2a="" id="conversion"
																   transform="translate(567.976 210.905)">
																	<path data-v-c04d7b2a="" id="Path_13963"
																		  data-name="Path 13963"
																		  d="M13.474,6.51H1V5.376H12.1l-3.4-3.4.8-.8,4.37,4.37a.567.567,0,0,1-.4.968Z"
																		  transform="translate(-1 -1.172)"
																		  fill="#031219"/>
																	<path data-v-c04d7b2a="" id="Path_13964"
																		  data-name="Path 13964"
																		  d="M5.536,33.338l-4.37-4.37a.567.567,0,0,1,.4-.968H14.041v1.134H2.936l3.4,3.4Z"
																		  transform="translate(-1 -20.395)"
																		  fill="#031219"/>
																</g>
															</g>
														</svg>
													</div>
												</div>
												<div data-v-c04d7b2a=""
													 className="content d-flex flex-column align-items-center">
													<div data-v-c04d7b2a="" className="inputGroup mb-3 w-75"><input
														data-v-c04d7b2a="" type="number" placeholder="Nhập số tiền"
														aria-label="Recipient's username"
														aria-describedby="button-addon2"
														className="form-control w-100"/>
														<div data-v-c04d7b2a="" className="input-append">
															<button data-v-c04d7b2a="" type="button" id="button-addon2"
																	className="btn">Tất cả
															</button>
														</div>
													</div>
													<button data-v-c04d7b2a=""
															className="button btn-border-radius btn-large wbtn w-75 font-weight-bold">
														Chuyển Tiền
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div data-v-69e6b284="" data-v-c04d7b2a="">
									<div data-v-69e6b284="" tabIndex="-1" role="dialog" aria-hidden="true"
										 className="modal fade modal-info modalTransferSuccess">
										<div data-v-69e6b284="" className="modal-dialog h-100">
											<div data-v-69e6b284="" className="modal-content-info h-100">
												<button data-v-69e6b284="" type="button" aria-label="Close"
														className="close">
													<svg data-v-69e6b284="" xmlns="http://www.w3.org/2000/svg"
														 viewBox="0 0 32 32">
														<g data-v-69e6b284="" strokeLinecap="square"
														   strokeLinejoin="miter" strokeWidth="2" fill="currentColor"
														   stroke="currentColor" className="nc-icon-wrapper">
															<g data-v-69e6b284=""
															   className="nc-interact_menu-close-2-o-32">
																<path data-v-69e6b284="" fill="currentColor"
																	  stroke="currentColor" strokeMiterlimit="10"
																	  d="M2 6h28"
																	  transform="translate(0 10.00) rotate(45.00 16 6)"/>
																<path data-v-69e6b284="" data-color="color-2"
																	  fill="currentColor" strokeMiterlimit="10"
																	  d="M2 16h28" opacity="0"/>
																<path data-v-69e6b284="" fill="currentColor"
																	  stroke="currentColor" strokeMiterlimit="10"
																	  d="M2 26h28"
																	  transform="translate(0 -10) rotate(-45 16 26)"/>
															</g>
														</g>
													</svg>
												</button>
												<div data-v-69e6b284="" className="modal-body-popup mobile-version">
													<div data-v-69e6b284="" className="h-100 d-flex flex-column">
														<div data-v-69e6b284=""><h4 data-v-69e6b284=""
																					className="font-24 font-weight-700">Chuyển
															tiền thành công</h4></div>
														<div data-v-69e6b284="" className="content text-center"><img
															data-v-69e6b284=""
															src="data:image/svg+xml;base64,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"
															alt="../../../../../assets.images/icon-binary/icon-success-green.svg"
															className="image" style={{display: 'none'}}/> <img
															data-v-69e6b284=""
															src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTM3LjE5OCIgaGVpZ2h0PSIxODEuOTU3IiB2aWV3Qm94PSIwIDAgMTM3LjE5OCAxODEuOTU3Ij4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB4MT0iMC41IiB4Mj0iMC41IiB5Mj0iMSIgZ3JhZGllbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMyZTAwYWQiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZjcwMDg0Ii8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPGZpbHRlciBpZD0iUGF0aF8yNDExMyIgeD0iNDAuMDk1IiB5PSI2NS45OSIgd2lkdGg9IjU2LjAyMSIgaGVpZ2h0PSI1Ni4wMiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPGZlT2Zmc2V0IGR5PSIzIiBpbnB1dD0iU291cmNlQWxwaGEiLz4KICAgICAgPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMyIgcmVzdWx0PSJibHVyIi8+CiAgICAgIDxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAuMTYxIi8+CiAgICAgIDxmZUNvbXBvc2l0ZSBvcGVyYXRvcj0iaW4iIGluMj0iYmx1ciIvPgogICAgICA8ZmVDb21wb3NpdGUgaW49IlNvdXJjZUdyYXBoaWMiLz4KICAgIDwvZmlsdGVyPgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfMTMzMTgiIGRhdGEtbmFtZT0iR3JvdXAgMTMzMTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTkgLTEwMCkiPgogICAgPGcgaWQ9ImJ1c3NpbmVzcy1hbmQtZmluYW5jZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTcuOTk1IDEwMC4wMDEpIj4KICAgICAgPHBhdGggaWQ9IlBhdGhfMzA1MzgiIGRhdGEtbmFtZT0iUGF0aCAzMDUzOCIgZD0iTTIwMi40NzcsMTQ3LjczOXY1OC43YTExLjc0MSwxMS43NDEsMCwwLDEtMTEuNzM5LDExLjczOUg4OC43OTFhMTEuNzQxLDExLjc0MSwwLDAsMS0xMS43MzktMTEuNzM5di01OC43QTExLjc0MSwxMS43NDEsMCwwLDEsODguNzkxLDEzNkgxOTAuNzM4QTExLjc0MSwxMS43NDEsMCwwLDEsMjAyLjQ3NywxNDcuNzM5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwLjE2IC04Ni4xMDkpIiBmaWxsPSIjZDFlN2ZmIi8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzMwNTM5IiBkYXRhLW5hbWU9IlBhdGggMzA1MzkiIGQ9Ik0xODUuNjIxLDEzNmMtMTYuNjg3LDQ2LjU1OC01Ny4zNjUsNzAuODIzLTEwOC4wNjYsNzQuMDE5LS43OS0yLjQ1OC0uNTU4LDEuNi0uNTU4LTYyLjI4QTExLjc0MSwxMS43NDEsMCwwLDEsODguNzM2LDEzNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMC4xMDUgLTg2LjEwOSkiIGZpbGw9IiNlOGYzZmYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMzA1NDAiIGRhdGEtbmFtZT0iUGF0aCAzMDU0MCIgZD0iTTEwMywzMTUuMjExSDg4Ljc5MWExMS43NDEsMTEuNzQxLDAsMCwxLTExLjczOS0xMS43MzlWMjg5LjI2QTI1Ljk1LDI1Ljk1LDAsMCwxLDEwMywzMTUuMjExWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwLjE2IC0xODMuMTQ2KSIgZmlsbD0iI2I5ZGNmZiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF8zMDU0MSIgZGF0YS1uYW1lPSJQYXRoIDMwNTQxIiBkPSJNODguNzkxLDEzNkgxMDNhMjUuOTUsMjUuOTUsMCwwLDEtMjUuOTUxLDI1Ljk1MVYxNDcuNzM5QTExLjc0MSwxMS43NDEsMCwwLDEsODguNzkxLDEzNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMC4xNiAtODYuMTA5KSIgZmlsbD0iI2QxZTdmZiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF8zMDU0MiIgZGF0YS1uYW1lPSJQYXRoIDMwNTQyIiBkPSJNMzc0LjE2MywxNDcuNzM5djE0LjIxMkEyNS45NSwyNS45NSwwLDAsMSwzNDguMjEyLDEzNmgxNC4yMTJBMTEuNzQxLDExLjc0MSwwLDAsMSwzNzQuMTYzLDE0Ny43MzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTgxLjg0NiAtODYuMTA5KSIgZmlsbD0iI2I5ZGNmZiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF8zMDU0MyIgZGF0YS1uYW1lPSJQYXRoIDMwNTQzIiBkPSJNMzc0LjE2MywyODkuMjZ2MTQuMjEyYTExLjc0MSwxMS43NDEsMCwwLDEtMTEuNzM5LDExLjczOUgzNDguMjEyQTI1Ljk1LDI1Ljk1LDAsMCwxLDM3NC4xNjMsMjg5LjI2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE4MS44NDYgLTE4My4xNDYpIiBmaWxsPSIjYjlkY2ZmIi8+CiAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTczMiIgZGF0YS1uYW1lPSJFbGxpcHNlIDE3MzIiIGN4PSIxOS40NjEiIGN5PSIxOS40NjEiIHI9IjE5LjQ2MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEwLjE0MyA3MS41MTcpIiBmaWxsPSIjYjlkY2ZmIi8+CiAgICAgIDxnIGlkPSJHcm91cF8xMzMxNyIgZGF0YS1uYW1lPSJHcm91cCAxMzMxNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjYuODU0IDQ5Ljg5MSkiPgogICAgICAgIDxwYXRoIGlkPSJQYXRoXzMwNTQ0IiBkYXRhLW5hbWU9IlBhdGggMzA1NDQiIGQ9Ik0xMDAuNDExLDMwNC4wMzNhMTYwLjkzOCwxNjAuOTM4LDAsMCwxLTE3LjA0LDIuNTU4LDUuODYzLDUuODYzLDAsMCwxLTYuNDIxLTUuODQyYzAtMi4zOS4wMzctNS45MjkuMDM3LTExLjQ4OEEyNS45NCwyNS45NCwwLDAsMSwxMDAuNDExLDMwNC4wMzNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzYuOTUgLTIzMy4wMzcpIiBmaWxsPSIjZDFlN2ZmIi8+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfMzA1NDUiIGRhdGEtbmFtZT0iUGF0aCAzMDU0NSIgZD0iTTM1NS44MywxNDAuMDM3Yy0xLjE4LDIuOTQ2LTIuNTMzLDUuOTcxLTQuMDg2LDkuMDM4QTI1LjgwOSwyNS44MDksMCwwLDEsMzQ4LjIxMiwxMzZoNC45QTIuOTM3LDIuOTM3LDAsMCwxLDM1NS44MywxNDAuMDM3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI0OC43IC0xMzYpIiBmaWxsPSIjZDFlN2ZmIi8+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfMzA1NDYiIGRhdGEtbmFtZT0iUGF0aCAzMDU0NiIgZD0iTTIzMy44NzEsMjE0LjcyM2ExMDYuNDE5LDEwNi40MTksMCwwLDEtMjUuNTkxLDE4LjE2MywxOS40NjMsMTkuNDYzLDAsMSwxLDI1LjU5MS0xOC4xNjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUxLjY2MyAtMTczLjMyNCkiIGZpbGw9IiNkMWU3ZmYiLz4KICAgICAgPC9nPgogICAgICA8cGF0aCBpZD0iUGF0aF8zMDU0NyIgZGF0YS1uYW1lPSJQYXRoIDMwNTQ3IiBkPSJNMTgwLjU3Nyw0NC4wMjFINzguNjMyQTE3LjYyOSwxNy42MjksMCwwLDAsNjEuMDIzLDYxLjYzdjU4LjdhMTcuNjI5LDE3LjYyOSwwLDAsMCwxNy42MDksMTcuNjA5SDE4MC41NzdhMTcuNjI5LDE3LjYyOSwwLDAsMCwxNy42MDktMTcuNjA5VjYxLjYzQTE3LjYyOSwxNy42MjksMCwwLDAsMTgwLjU3Nyw0NC4wMjFaTTE2MS4wNDIsMTI2LjJIOTguMTY3YTMxLjkwNywzMS45MDcsMCwwLDAtMjUuNC0yNS40VjgxLjE2NWEzMS45MDcsMzEuOTA3LDAsMCwwLDI1LjQtMjUuNGg2Mi44NzVhMzEuOTA3LDMxLjkwNywwLDAsMCwyNS40LDI1LjRWMTAwLjc5QTMxLjkwNywzMS45MDcsMCwwLDAsMTYxLjA0MiwxMjYuMlptMjUuNC02NC41NjV2Ny40NjRhMjAuMTY1LDIwLjE2NSwwLDAsMS0xMy4zMzMtMTMuMzMzaDcuNDY0QTUuODc2LDUuODc2LDAsMCwxLDE4Ni40NDcsNjEuNjNaTTc4LjYzMiw1NS43NjFIODYuMUEyMC4xNjYsMjAuMTY2LDAsMCwxLDcyLjc2Miw2OS4wOTRWNjEuNjNhNS44NzYsNS44NzYsMCwwLDEsNS44Ny01Ljg3Wm0tNS44Nyw2NC41NjV2LTcuNDY0QTIwLjE2NiwyMC4xNjYsMCwwLDEsODYuMSwxMjYuMkg3OC42MzJBNS44NzYsNS44NzYsMCwwLDEsNzIuNzYyLDEyMC4zMjZabTEwNy44MTUsNS44N2gtNy40NjRhMjAuMTY0LDIwLjE2NCwwLDAsMSwxMy4zMzMtMTMuMzMzdjcuNDY0QTUuODc2LDUuODc2LDAsMCwxLDE4MC41NzcsMTI2LjJaTTEyOS42LDY1LjY0NmEyNS4zMzIsMjUuMzMyLDAsMSwwLDI1LjMzMiwyNS4zMzJBMjUuMzYxLDI1LjM2MSwwLDAsMCwxMjkuNiw2NS42NDZabTAsMzguOTI0QTEzLjU5MywxMy41OTMsMCwxLDEsMTQzLjIsOTAuOTc4LDEzLjYwOCwxMy42MDgsMCwwLDEsMTI5LjYsMTA0LjU3MVptMTQuNjc0LTg2Ljk2M2E1Ljg3LDUuODcsMCwwLDEsNS44Ny01Ljg3aDI4LjAxN2wtMS43MTktMS43MTlhNS44NjksNS44NjksMCwxLDEsOC4zLTguM2wxMS43MzcsMTEuNzM3YTUuODYsNS44NiwwLDAsMSwxLjM3Miw2LjEzM2MtLjYsMS42NjUtLjM2MSwxLjE2Mi0xMy4xMDksMTMuOTA5YTUuODY5LDUuODY5LDAsMSwxLTguMy04LjNsMS43MTktMS43MTlIMTUwLjE0OEE1Ljg2OSw1Ljg2OSwwLDAsMSwxNDQuMjc5LDE3LjYwOFpNMTE0LjkzMSwxNjQuMzQ4YTUuODcsNS44NywwLDAsMS01Ljg3LDUuODdIODEuMDQ0bDEuNzE5LDEuNzE5YTUuODY5LDUuODY5LDAsMCwxLTguMyw4LjNjLTEyLjUyMS0xMi41MjEtMTIuMDA1LTExLjkzNi0xMi40Ny0xMi42MzFhNS44NzUsNS44NzUsMCwwLDEtLjU0MS01LjVjLjYtMS40NTcuNDEtMS4wNDMsMTMuMDExLTEzLjY0NGE1Ljg2OSw1Ljg2OSwwLDAsMSw4LjMsOC4zbC0xLjcxOSwxLjcxOWgyOC4wMTdhNS44Nyw1Ljg3LDAsMCwxLDUuODcsNS44N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIGZpbGw9InVybCgjbGluZWFyLWdyYWRpZW50KSIvPgogICAgPC9nPgogICAgPGcgaWQ9ImwtY2hlY2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2OC4wOTUgMTcxLjk5KSI+CiAgICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDEsIDAsIDAsIDEsIC00OS4xLCAtNzEuOTkpIiBmaWx0ZXI9InVybCgjUGF0aF8yNDExMykiPgogICAgICAgIDxwYXRoIGlkPSJQYXRoXzI0MTEzLTIiIGRhdGEtbmFtZT0iUGF0aCAyNDExMyIgZD0iTTQ2LjAxLDYyLjAyYTE5LjAxLDE5LjAxLDAsMSwxLDE5LjAxLTE5LjAxQTE5LjAxLDE5LjAxLDAsMCwxLDQ2LjAxLDYyLjAyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjIuMSA0Ny45OSkiIGZpbGw9IiNmZmYiLz4KICAgICAgPC9nPgogICAgPC9nPgogICAgPHRleHQgaWQ9IlciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE5NyAxOTgpIiBmaWxsPSIjMGUwMDMxIiBmb250LXNpemU9IjIwIiBmb250LWZhbWlseT0iVWJ1bnR1LUJvbGQsIFVidW50dSIgZm9udC13ZWlnaHQ9IjcwMCI+PHRzcGFuIHg9Ii0xOC45NiIgeT0iMCI+VzwvdHNwYW4+PC90ZXh0PgogIDwvZz4KPC9zdmc+Cg=="
															alt="../../../../../assets.images/icon-binary/icon-success-green.svg"
															className="image" style={{display: 'none'}}/>
															<div data-v-69e6b284="" className="mt-5">
																<span
																	data-v-69e6b284="">Bạn đã chuyển thành công <span
																	data-v-69e6b284=""
																	className="color-blue font-weight-700"><b
																	data-v-69e6b284=""> WIN</b></span> đến <span
																	data-v-69e6b284=""> Live Account</span></span>
															</div>
														</div>
														<div data-v-69e6b284="" className="text-center mt-auto">
															<button data-v-69e6b284=""
																	className="button btn-radius btn-large wbtn w-100 font-weight-bold">
																Đóng
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
						<section data-v-efb97944="" className="sectionTable container pb-lg-4">
							<div data-v-efb97944="" className="balance">
								<div data-v-efb97944="" className="wrapBalance">
									<div data-v-efb97944="" className="boxBalance">
										<div data-v-7ab9e0ba="" data-v-efb97944="" className="history">
											<div className='headerContent d-flex flex-lg-row flex-column justify-content-between align-items-center mb-3'>
												<h4 data-v-7ab9e0ba="" className="history-title mb-3">Lịch sử giao dịch</h4>
												<div data-v-7a0c51c4="" className="d-lg-flex align-items-end">
													<DateRangePicker handleChangeDateRange={this.handleChangeDateRange} initStart={filter_from} initEnd={filter_to} />
												</div>
											</div>
											<div data-v-7ab9e0ba="" className="history-body">
												<div data-v-7ab9e0ba="" className="history-content">
													<div data-v-7ab9e0ba="" className="box-result" style={{ borderRadius: '3px' }}>
														<DataTable
															columns={this.columns}
															data={data}
															pagination
															paginationServer
															paginationTotalRows={total}
															onChangeRowsPerPage={this.handlePerRowsChange}
															onChangePage={this.handlePageChange}
															sortServer
															onSort={this.onSort}
														/>
													</div>
												</div>
											</div>
											<div data-v-e2796250="" data-v-7ab9e0ba="" className="authPopup">
												<div data-v-e2796250="" tabIndex="-1" role="dialog" aria-hidden="true"
													 className="modal fade modalHistory">
													<div data-v-e2796250="" className="modal-dialog modal-auth">
														<div data-v-e2796250="" className="close-page"><span
															data-v-e2796250="" className="pe pe-7s-close"/></div>
														<div data-v-e2796250="" className="modal-content">
															<div data-v-e2796250="" className="row h-100">
																<div data-v-e2796250=""
																	 className="col-lg-5 d-none d-md-block">
																	<div data-v-e2796250=""
																		 className="leftBackground background-img"/>
																</div>
																<div data-v-e2796250=""
																	 className="col-lg-7 align-items-center justify-content-center blockformPopup">
																	<div data-v-e2796250=""
																		 className="divCourseHistory"><h4
																		data-v-e2796250="" className="colorWhite"/>
																		<div data-v-e2796250=""
																			 className="detailCourseHistory">
																			<div data-v-e2796250="" className="d-flex">
																				<span data-v-e2796250=""
																					  className="titleCourseHistory mr-2">Thời gian</span>
																				<span data-v-e2796250=""
																					  className="ml-auto colorWhite"/>
																			</div>
																			<div data-v-e2796250="" className="d-flex">
																				<span data-v-e2796250=""
																					  className="titleCourseHistory  mr-auto">Giá trị</span>
																				<span data-v-e2796250=""
																					  className="green">+$0.00</span>
																			</div>
																			<div data-v-e2796250="" className="d-flex">
																				<span data-v-e2796250=""
																					  className="titleCourseHistory  mr-2">Tình trạng</span>
																				<span data-v-e2796250=""
																					  className="ml-auto colorWhite"/>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</div>
					{is_show_withdrawal_box && <div data-v-f99ecb42="" data-v-b0e45e8c="" className="boxFix">
						<div data-v-f99ecb42="" className="boxAuthentication show">
							<div data-v-f99ecb42=""
								 className="contentAuthentication d-flex flex-column align-items-center justify-content-between">
								<div data-v-f99ecb42=""
									 className="header d-flex align-items-center justify-content-between w-100">
									<a data-v-f99ecb42="" href="/"
									   style={{ backgroundImage: `url(${asset_logo})` }}
									   className="logoLogin mb-0 router-link-active">DIGINEX</a>
									<div data-v-f99ecb42="" onClick={this.onClickWithdrawal} className="close-page">
										<span data-v-f99ecb42="" className="pe pe-7s-close"/>
									</div>
								</div>
								<div data-v-f99ecb42="" className="formWapper w-100">
									<form data-v-f99ecb42="" className="loginForm colorWhite mt-0"><h2
										data-v-f99ecb42=""
										className="mt5m font-24 color-white font-weight-bold mb-lg-5 mb-3">Yêu cầu rút
										tiền</h2>
										<div data-v-f99ecb42=""
											 className="md-field md-theme-default md-has-placeholder"><label
											data-v-f99ecb42="" htmlFor="md-input-3037ci4xp">Số tiền rút ($) *</label>
											<input data-v-f99ecb42="" value={formatNumber(withdrawal_amount)}
												   onKeyPress={this.onKeyPress}
												   onBlur={this.onFocusout}
												   onChange={this.onChangeInput('withdrawal_amount')} type="text"
												   aria-autocomplete="false"
												   autoComplete="off" id="md-input-3037ci4xp"
												   placeholder="Số tiền cần rút" className="md-input"/>
											<small style={{color: 'red'}}>Tối thiểu: ${formatNumber(minimum_withdrawal)}</small><br/>
											<small style={{color: 'yellowgreen'}}>Phí rút tiền: ${formatNumber(withdrawal_cost)}</small><br/>
											<small style={{color: 'green'}}>
												Số tiền còn lại: <b>${formatNumber(amount_receive)}</b> = <b>{ formatNumber(vnd_per_usd * amount_receive) }VNĐ</b>
											</small>
										</div>
										<div data-v-f99ecb42=""
											 className="md-field md-theme-default md-has-placeholder"><label
											data-v-f99ecb42="" htmlFor="md-input-3037ci4xp">Ngân hàng nhận *</label>
											<input data-v-f99ecb42="" value={withdrawal_bank_name}
												   onKeyPress={this.onKeyPress}
												   onChange={this.onChangeInput('withdrawal_bank_name')} type="text"
												   aria-autocomplete="false"
												   autoComplete="off" id="md-input-3037ci4xp"
												   placeholder="Ngân hàng rút về" className="md-input"/>
											<small className="md-error"/>
										</div>
										<div data-v-f99ecb42=""
											 className="md-field md-theme-default md-has-placeholder"><label
											data-v-f99ecb42="" htmlFor="md-input-3037ci4xp">Số tài khoản *</label>
											<input data-v-f99ecb42="" value={withdrawal_bank_number}
												   onKeyPress={this.onKeyPress}
												   onChange={this.onChangeInput('withdrawal_bank_number')} type="text"
												   aria-autocomplete="false"
												   autoComplete="off" id="md-input-3037ci4xp"
												   placeholder="Số tài khoản ngân hàng" className="md-input"/>
											<small className="md-error"/>
										</div>
										<div data-v-f99ecb42=""
											 className="md-field md-theme-default md-has-placeholder"><label
											data-v-f99ecb42="" htmlFor="md-input-3037ci4xp">Tên tài khoản *</label>
											<input data-v-f99ecb42="" value={withdrawal_bank_account}
												   onKeyPress={this.onKeyPress}
												   onChange={this.onChangeInput('withdrawal_bank_account')} type="text"
												   aria-autocomplete="false"
												   autoComplete="off" id="md-input-3037ci4xp"
												   placeholder="Tên chủ tài khoản" className="md-input"/>
											<small className="md-error"/>
										</div>
										{tl_id && <div data-v-f99ecb42=""
											 className="md-field md-theme-default md-has-placeholder"><label
											data-v-f99ecb42="" htmlFor="md-input-3037ci4xp">Mã OTP từ ứng dụng Telegram *</label>
											<div className='otp-box'>
												<input data-v-f99ecb42=""
													   value={otp}
													   maxLength={6}
													   onKeyPress={this.onKeyPress}
													   id="md-input-3037ci4xp"
													   onChange={this.onChangeInput('otp')}
													   type="number" className="md-input"/>
												<button type='button' onClick={this.onSendOTP} className='btn btn-primary'>Lấy OTP</button>
											</div>
										</div>}
										<div data-v-f99ecb42="" className="form-group text-center">
											<button data-v-f99ecb42="" type='button' onClick={this.onRequestWithdrawal}
													disabled={isDisableButton}
													className={'btn-large btn-radius w-100 ' + (isDisableButton ? 'btn-secondary btn' : 'siginButton button wbtn')}> Gửi
												Yêu Cầu
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		memberReducer: state.memberReducer,
		appReducer: state.appReducer
	};
}

export default connect(mapStateToProps, {
	fetchingUser,
	fetchingUserSuccess
})(withRouter(Wallet));
